import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  scale020,
  scale100,
  scale200,
  spaceXXL,
  cornerRadiusL,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const Container = styled.section`
  margin-bottom: calc(${scale020} + ${scale200});
`;

export const Text = styled(BodyCopy)`
  margin-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    margin-bottom: calc(2 * ${scale100});
  }
`;

export const VideoWrapper = styled.div`
  margin-left: -${scale100};
  margin-right: -${scale100};

  @media ${mediaConfined} {
    margin: 0;

    & > div {
      border-radius: ${cornerRadiusL};
    }

    & > iframe {
      border-radius: ${cornerRadiusL};
    }
  }
`;
